<template>
  <b-form @submit.prevent="validForm">
    <div class="row">
      <div class="col-3">
        <b-form-group label="Código da unidade">
          <b-form-input  v-model="unidadeEdit.codigo">

          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-9">
        <b-form-group label="Unidade">
          <b-form-input 
            :state="$v.unidadeEdit.$error ? !$v.unidadeEdit.unidade.$error : null"
            v-model="unidadeEdit.unidade"> </b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group label="Cidade">
          <b-form-input 
            :state="$v.unidadeEdit.$error ? !$v.unidadeEdit.cidade.$error : null"
            v-model="unidadeEdit.cidade"> </b-form-input>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group label="Local">
          <b-form-input 
            :state="$v.unidadeEdit.$error ? !$v.unidadeEdit.local.$error : null"
            v-model="unidadeEdit.local"> </b-form-input>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group label="Total">
          <b-form-input 
            type="number"
            v-model.number="unidadeEdit.total"> </b-form-input>
        </b-form-group>
      </div>
    </div>
    <b-button type="submit" variant="primary">Salvar</b-button>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: ['onSubmit', 'onEdit', 'unidadeEdit', 'codigo'],
  data() {
    return {}
  },
  validations: {
    unidadeEdit: {
      unidade: { required },
      cidade: { required },
      local: { required },
    },
  },
  mounted(){
    !this.unidadeEdit._id ? this.unidadeEdit.codigo = this.codigo + 1 : ''
  },
  methods: {
    invalidForm() {
      this.$bvToast.toast('Há campos que não foram preenchidos', {
        variant: 'danger',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
      this.formsubmit = true
    },
    validForm() {
      this.$v.$touch()

      !this.$v.unidadeEdit.$error
        ? this.unidadeEdit._id
          ? this.onEdit()
          : this.onSubmit()
        : this.invalidForm()
    },
  },
}
</script>

<style>
</style>